// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.innerContainer {
  padding: 40px;
}

.orderRow {
  font-size: 14px;
}

.timelineList {
  margin: 0px;
}

.timelinestatus {
  font-size: 16px;
}

.timeline {
  margin: auto;
  padding-top: 20px;
}

.orderHeaderParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* gap: 5px; */
  margin-bottom: 10px;
}

.cancelBtn {
  background-color: rgb(54, 54, 54) !important;
  color: white;
  padding: 10px 40px;
  font-size: 13p;
}

.cancelBtn:disabled {
  color: gray !important;
}

.orderHeaderContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.btnContainer {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.requestHeaderContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}

.paid {
  color: green;
  font-weight: bold;
}

.unpaid {
  color: rgb(198, 198, 8);
  font-weight: bold;
}

.detailCard {
  width: 100%;
}

.slotsContainer{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

.berthTimeSlot{
  padding: 0px 5px;
  background-color: rgb(153, 217, 165);
  border-radius: 5px;
}

.completeTextContainer{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.CartItemContainer {
  width: 100% !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between !important;
  gap: 10px;
}
.orderItems {
  width: 100%;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between !important;
  gap: 20px;
}
.firstCartItemContainer {
  width: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/yacht/home/nested/berthDetail/BerthDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;EACzC,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,SAAS;AACX;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".innerContainer {\n  padding: 40px;\n}\n\n.orderRow {\n  font-size: 14px;\n}\n\n.timelineList {\n  margin: 0px;\n}\n\n.timelinestatus {\n  font-size: 16px;\n}\n\n.timeline {\n  margin: auto;\n  padding-top: 20px;\n}\n\n.orderHeaderParent {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  /* gap: 5px; */\n  margin-bottom: 10px;\n}\n\n.cancelBtn {\n  background-color: rgb(54, 54, 54) !important;\n  color: white;\n  padding: 10px 40px;\n  font-size: 13p;\n}\n\n.cancelBtn:disabled {\n  color: gray !important;\n}\n\n.orderHeaderContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.btnContainer {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.requestHeaderContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 15px;\n}\n\n.paid {\n  color: green;\n  font-weight: bold;\n}\n\n.unpaid {\n  color: rgb(198, 198, 8);\n  font-weight: bold;\n}\n\n.detailCard {\n  width: 100%;\n}\n\n.slotsContainer{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.berthTimeSlot{\n  padding: 0px 5px;\n  background-color: rgb(153, 217, 165);\n  border-radius: 5px;\n}\n\n.completeTextContainer{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.CartItemContainer {\n  width: 100% !important;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between !important;\n  gap: 10px;\n}\n.orderItems {\n  width: 100%;\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between !important;\n  gap: 20px;\n}\n.firstCartItemContainer {\n  width: auto !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
